// import { useState } from 'react' // Ya no se usa
// import reactLogo from './assets/react.svg' // Eliminado
// import viteLogo from '/vite.svg' // Ya no se usa
// import './App.css' // Eliminado

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './components/providers/theme-provider';
import { LoginPage } from './pages/LoginPage';
import { MainLayout } from './components/layout/MainLayout'; // Importar Layout
import { RequireAuth } from './features/auth/components/RequireAuth'; // Importar RequireAuth
import DashboardPage from './pages/DashboardPage'; // Importar Dashboard como default import
import { EmpresasPage } from './pages/EmpresasPage';
import { UsuariosPage } from './pages/UsuariosPage';
import { TextosPage } from './pages/TextosPage';
import { PerfilPage } from './pages/PerfilPage';
import ClientePage from './pages/ClientePage';
import { RequireClientesEnabled } from './features/auth/components/RequireClientesEnabled';
import { AuthInitializer } from './components/AuthInitializer';
// import { NotFoundPage } from './pages/NotFoundPage';

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="empresas-app-theme">
      <AuthInitializer>
        <Routes>
          {/* Rutas Públicas */}
          <Route path="/login" element={<LoginPage />} />

          {/* Rutas Protegidas anidadas dentro de MainLayout */}
          <Route element={<MainLayout />}>
            <Route element={<RequireAuth />}> { /* Protección básica de autenticación */}
              <Route path="/" element={<DashboardPage />} />
              <Route path="/perfil" element={<PerfilPage />} />

              {/* Ruta protegida para textos - requiere al menos un bot habilitado */}
              <Route element={<RequireAuth requiredBots={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} />}>
                <Route path="/textos" element={<TextosPage />} />
              </Route>

              {/* Ruta protegida para clientes_enabled */}
              <Route element={<RequireClientesEnabled />}> 
                <Route path="/clientes" element={<ClientePage />} />
              </Route>

              {/* Rutas solo para administradores y superadmins */}
              <Route element={<RequireAuth allowedRoles={['admin', 'superadmin']} />}> 
                <Route path="/usuarios" element={<UsuariosPage />} />
              </Route>

              {/* Rutas exclusivas para superadmin */}
              <Route element={<RequireAuth allowedRoles={['superadmin']} />}> 
                <Route path="/empresas" element={<EmpresasPage />} />
              </Route>
            </Route>
          </Route> 

          {/* Ruta Catch-all (Podría ser una página 404 dentro del layout si está autenticado) */}
          {/* <Route path="*" element={<NotFoundPage />} /> */}
          {/* Por ahora, redirigir a login si no coincide ninguna ruta */}
          <Route path="*" element={<Navigate to="/" replace />} /> 
          {/* Considerar redirigir a '/' si ya está autenticado y la ruta no existe */}

        </Routes>
      </AuthInitializer>
    </ThemeProvider>
  );
}

export default App;
